import { CssVarsProvider } from '@mui/joy/styles';
import { ParticlesComponent } from './components/ParticlesComponent';
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <CssVarsProvider defaultColorScheme='dark'>
      <ParticlesComponent>
        <LandingPage></LandingPage>
      </ParticlesComponent>
    </CssVarsProvider>
  );
}

export default App;